import classNames from 'classnames'
import { MdArrowBack } from 'react-icons/md'
import { Link } from 'react-router-dom'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  backgroundColor?: 'light' | 'dark'
  title?: string
  to: string
}

const BackNavigation = ({ backgroundColor, title, to }: Props): ReactElement => {
  const backNavigationClasses = classNames('back-navigation-component', {
    'dark-background': backgroundColor === 'dark',
  })

  return (
    <div className={backNavigationClasses}>
      <Link className="back-navigation-component-link" to={to}>
        <MdArrowBack className="back-navigation-component-link-icon" size={20} />
        <div className="back-navigation-component-link-title">{title}</div>
      </Link>
    </div>
  )
}

export default BackNavigation
